define('modules/editor/views/elements/section',['require','exports','module','base/collectionview','../../models/editorstate','lib/util','../brick_view_factory','ldsh!../../templates/section_amp','ldsh!../../templates/section','../../behaviours/draggable','../../behaviours/selectable','../../behaviours/render_with_property_groups','../../behaviours/hoverable','../../behaviours/droppable'],function(require, exports, module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
      EditorState = require("../../models/editorstate"),
      GroupState = EditorState.groupState,
      util = require("lib/util");

  module.exports = CollectionView.extend({
    initialize: function(options) {
      this.data = options.parent.data;
      this.collection = this.model.elements;
      //this.setCollectionListeners();
      this.listenTo(this.model, "change", this.render);
      // Makes section selected when clicked in elements tree
      this.listenTo(this.model, "selectFromTree", function() {
        EditorState.selectElement(this);
      });
      // Makes a rerender of the elements tree when the id is changed
      this.listenTo(this.model.getPropertyGroup('idclass'), "change:id", function(model) {
        EditorState.trigger("idChanged", model);
      });
    },
    //factory is needed here to render specific element views
    //brick factory decouples area view from the rest
    itemView: require("../brick_view_factory"),
    itemContainer: ".js-section-elements",
    // itemContainer: ".js-content",
    template: function () { return this.getSectionTemplate(); },
    //attributes: { draggable: "true" },
    className: "ed-panel-item ed-item-section",
    //onAddChildView: _.bind(GroupState.replaceViewWith, GroupState),
    onAddChildView: function(){
      if (!EditorState.isGenerateMode()) {
        GroupState.replaceViewWith.apply(GroupState, arguments);
      }
    },
    getSectionTemplate: function () {
      if (EditorState.getAMPState()) {
        return require("ldsh!../../templates/section_amp");
      }

      return require("ldsh!../../templates/section");
    },
    getDelta: function() {
      var offset = this.$el.offset(),
          pageOffset = this.$el.parents(".lpg-page").offset();
      return {
        top: offset.top - pageOffset.top,
        left: offset.left - pageOffset.left
      };
    },
    updateGroupStateViews: function() {
      _.each(this._childViews, function(view) {
        GroupState.refreshView(view);
        if (view.model.name === "element:area") {
          this.updateGroupStateViews.call(view);
        }
      }, this);
    },
  });

  util.mixin(module.exports, require("../../behaviours/draggable"));
  util.mixin(module.exports, require("../../behaviours/selectable"));
  util.mixin(module.exports, require("../../behaviours/render_with_property_groups"));
  util.mixin(module.exports, require("../../behaviours/hoverable"));
  util.mixin(module.exports, require("../../behaviours/droppable"));

});

